import { actions, MARKET_DATA_STORE_NAME } from './store';
import { frontendActions } from '@cmctechnology/webinvest-store-frontend';
import { CmcWebApi } from '@cmctechnology/webinvest-api-client-web-trading';
import { CountryAlpha3Code } from '@cmctechnology/webinvest-constants';
import { Dispatch } from '@reduxjs/toolkit';
import { MARKET_DATA_API_NAMES } from './models/marketDataApiNames';

export const fetchTheScreenerDetails = (count: number = 0, countryIsoCode: string = CountryAlpha3Code.AUS) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const request: CmcWebApi.MarketInformation.TheScreenerUpgradeDowngradeRequest1 = { Count: count, CountryIsoCode: countryIsoCode };
      const response = await frontendActions.webTradingApiCall<CmcWebApi.MarketInformation.TheScreenerUpgradeDowngradeModel1>(
        MARKET_DATA_STORE_NAME,
        MARKET_DATA_API_NAMES.TheScreenerGetAll1,
        request,
        dispatch
      );
      dispatch<any>(actions.screenerFetched(response));
    } catch {}
  };
};
